// !!!!!!!!!!!!!!!!!!!!!!IMPORTANT!!!!!!!!!!!!!!!!!!!!
//
// do not use it as switching layouts breaks the dropdown functionality
//
import "@hotwired/turbo-rails"
import "./controllers"

import "@tabler/core/js/tabler"

import BugsnagPerformance from '@bugsnag/browser-performance'
BugsnagPerformance.start({ apiKey: 'bee7ff746f0414b36349d17fe96a0963', releaseStage: 'production'})

// Import Capacitor for native apps
import { Capacitor } from '@capacitor/core';

// Load Capacitor-specific features if we're in a native app
if (Capacitor.isNativePlatform()) {
  import('./capacitor.js').then(module => {
    // Capacitor-specific initialization is handled in the module
  });
} else {
  // Web-specific PWA features
  // service worker for PWA
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(reg => {
          // Listen for updates
          reg.onupdatefound = () => {
            const installingWorker = reg.installing;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('New content is available; please refresh.');
                  // Optional: force update
                  // window.location.reload();
                } else {
                  console.log('Content (service worker) is cached for offline use.');
                }
              }
            };
          };
        }).catch(error => {
          console.error('Error during service worker registration:', error);
        });
    });
  }

  // PWA install prompt (only for web)
  var button = document.getElementById('installPWA');

  if (button != null) {
    // PWA install prompt
    let installPromptEvent;
    window.addEventListener('beforeinstallprompt', function(event) {
      // Prevent the mini-infobar from appearing on mobile
      event.preventDefault();
      // Stash the event so it can be triggered later
      installPromptEvent = event;
      // Update UI to notify the user they can add to home screen
      document.getElementById('installPWA').style.display = 'block';
      
      // Also show contact page install button if it exists
      var contactButton = document.getElementById('installPWAContact');
      if (contactButton) {
        contactButton.style.display = 'inline-block';
      }
    });

    button.addEventListener('click', function() {
      if (installPromptEvent) {
        installPromptEvent.prompt();

        installPromptEvent.userChoice.then(function(choiceResult) {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          installPromptEvent = null; // Clear the event
        });
      }
    });
    
    // Add event listener for contact page button if it exists
    var contactButton = document.getElementById('installPWAContact');
    if (contactButton) {
      contactButton.addEventListener('click', function() {
        if (installPromptEvent) {
          installPromptEvent.prompt();

          installPromptEvent.userChoice.then(function(choiceResult) {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt');
            } else {
              console.log('User dismissed the A2HS prompt');
            }
            installPromptEvent = null; // Clear the event
          });
        }
      });
    }
  }
}
